import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import OneEveryThreeStage, { OneEveryThreeStageParameters } from '../stages/filters/OneEveryThreeStage';
import OneToThreeStage, { OneToThreeStageParameters } from '../stages/filters/OneToThreeStage';
import { PipelinePhase } from '@visualizer/types';

export interface DensityBlockParams extends BlockParameters, OneToThreeStageParameters, OneEveryThreeStageParameters {
    isOneEveryThree: boolean;
}

/**
 * Get the density render scale based on the current ELEMENT_CURRENT_DENSITY setting
 */
export function getDensityRenderScale(densityMode: 0 | 1 | 2 | undefined = 0): number {
    // Only "1 to 3" scales up. "1 every 3" does not.
    return densityMode === 1 ? 3 : 1;
}

@AddMetadata({
    type: BlockKeys.Density,
    name: 'Density',
    description: 'Enable one to three or one every three filtering options',
    unique: true,
    pipelinePhase: PipelinePhase.Pre,
    visible: false,
})
class DensityBlock extends PipelineBlock<DensityBlockParams> {
    constructor(params: DensityBlockParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        const { isOneEveryThree } = this.getParams();
        return [isOneEveryThree ? new OneEveryThreeStage() : new OneToThreeStage()];
    }

    public override updateParams(params: Partial<DensityBlockParams>): void {
        const prevParams = this.getParams();
        const isOneEveryThreeChanged = params.isOneEveryThree !== undefined && params.isOneEveryThree !== prevParams.isOneEveryThree;

        super.updateParams(params);
        if (isOneEveryThreeChanged) this.updateStages();
    }
}

export default DensityBlock;
